const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M14.6949%2040H25.5763V10.9091H38.2712V0H2V10.9091H14.6949V40Z'%20fill='%23231F20'/%3e%3c/svg%3e";
export {
  e as default
};
